<section class="content-header">
  <div
    class="container-fluid d-flex justify-content-center align-items-center container-height">
    <div class="container">
      <div class="error-container">
        <h1>404</h1>
        <i
          class="fas fa-exclamation-triangle"
          style="font-size: 50px; color: rgba(115, 115, 18, 0.446)"></i>

        <p>Page Not Found</p>
        <span
          (keyup.enter)="goHome()"
          tabindex="0"
          class="home-button pointer"
          (click)="goHome()"
          >Go Home</span
        >
      </div>
    </div>
  </div>
</section>
